import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MarkdownFile } from '../models/markdown';
import { map } from 'rxjs/operators';
import { BaseApiService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class MarkdownsService extends BaseApiService {

  constructor(http: HttpClient) {
    super(http, 'markdowns');
  }

  getAll(): Observable<MarkdownFile[]> {
    return this._http.get<MarkdownFile[]>(this._baseUrl).pipe(
      map((res: any) => res.map((r: any) => ({
        ...r,
        createdAt: new Date(r.createdAt),
        updatedAt: r.updatedAt ? new Date(r.updatedAt) : undefined
      })))
    );
  }

  getById(id: number): Observable<MarkdownFile> {
    return this._http.get(`${this._baseUrl}/${id}`, { observe: 'response', responseType: 'text'}).pipe(
      map((response: HttpResponse<string>) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let itemName = 'untitled';
        if (contentDisposition) {
          const matches = /filename="([^"]+)"/.exec(contentDisposition);
          if (matches && matches[1]) {
            itemName = matches[1];
          }
        }

        return {
          itemName: itemName,
          content: response.body || ''
        } as MarkdownFile
      })
    );
  }

  create(filename: string, content: string): Observable<MarkdownFile> {
    const blob = new Blob([content], { type: 'text/markdown' });
    const formData = new FormData();
    formData.append('file', blob, `${filename}.md`);
    return this._http.post<MarkdownFile>(this._baseUrl, formData);
  }

  update(md: MarkdownFile, content: string): Observable<MarkdownFile> {
    const blob = new Blob([content], { type: 'text/markdown' });
    const formData = new FormData();
    formData.append('file', blob, `${md.itemName}.md`);
    return this._http.put<MarkdownFile>(`${this._baseUrl}/${md.id}`, formData);
  }

  changeStatus(id: number, enabled: boolean): Observable<MarkdownFile> {
    const body = { enabled: enabled };
    return this._http.patch<MarkdownFile>(`${this._baseUrl}/${id}/status`, body);
  }

  delete(id: number): Observable<any> {
    return this._http.delete<any>(`${this._baseUrl}/${id}`);
  }

  getVersions(id: number): Observable<MarkdownFile[]> {
    return this._http.get<MarkdownFile[]>(`${this._baseUrl}/${id}/versions`);
  }

  getByVersionId(id: number, versionId: number): Observable<MarkdownFile> {
    return this._http.get(`${this._baseUrl}/${id}/versions/${versionId}`, { observe: 'response', responseType: 'text' }).pipe(
      map((response: HttpResponse<string>) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let itemName = 'untitled';
        if (contentDisposition) {
          const matches = /filename="([^"]+)"/.exec(contentDisposition);
          if (matches && matches[1]) {
            itemName = matches[1];
          }
        }
        return {
          itemName: itemName,
          content: response.body || ''
        } as MarkdownFile
      })
    );
  }

}
